// Backend WasteType enum mirror (zayi / iç tüketim kategorileri)
export enum WasteType {
  STAFF_MEAL = 'STAFF_MEAL',
  TREAT = 'TREAT',
  BREAKAGE = 'BREAKAGE',
  EXPIRED = 'EXPIRED'
}
